import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Spinner } from "reactstrap";
import "./style.css";

import { AppContext } from "../context/AppProvider";
import { notify } from "../components/Toast/ToastCustom";
import {
  loginAdminWithEmail,
  loginStoreWithEmailFallback,
} from "../apis/authApiService";

export const Login = () => {
  const { setUser } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  let history = useHistory();

  const clearAuthStorage = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("vhgp-token");
  };

  const saveAuthStorage = (userPayload, token) => {
    localStorage.setItem("user", JSON.stringify(userPayload));
    localStorage.setItem("vhgp-token", token);
  };

  const isAdminRole = (roleId) => String(roleId) === "1";

  useEffect(() => {
    const inputs = document.querySelectorAll(".input");

    function addcl() {
      let parent = this.parentNode.parentNode;
      parent.classList.add("focus");
    }

    function remcl() {
      let parent = this.parentNode.parentNode;
      if (this.value === "") {
        parent.classList.remove("focus");
      }
    }

    inputs.forEach((input) => {
      input.addEventListener("focus", addcl);
      input.addEventListener("blur", remcl);
    });

    return () => {
      inputs.forEach((input) => {
        input.removeEventListener("focus", addcl);
        input.removeEventListener("blur", remcl);
      });
    };
  }, []);

  useEffect(() => {
    const userString = localStorage.getItem("user");
    const token = localStorage.getItem("vhgp-token");
    if (userString && token) {
      history.push("/");
    }
  }, [history]);

  const handleLogin = async () => {
    if (!email.trim() || !password) {
      notify("Vui lòng nhập email và mật khẩu", "Error");
      return;
    }

    setIsLoading(true);

    try {
      let response;

      try {
        response = await loginAdminWithEmail(email, password);
      } catch (error) {
        const statusCode = error?.response?.status;
        if (statusCode === 404 || statusCode === 405) {
          response = await loginStoreWithEmailFallback(email, password);
        } else {
          throw error;
        }
      }

      const payload = response?.data || {};
      const isSuccess = payload?.status?.success === true;
      const data = payload?.data || {};
      const token = data?.token;
      const roleId = data?.roleId;
      const accountId = data?.accountId || "";

      if (!isSuccess || !token) {
        notify("Sai tài khoản hoặc mật khẩu", "Error");
        clearAuthStorage();
        setIsLoading(false);
        return;
      }

      if (!isAdminRole(roleId)) {
        notify("Tài khoản không có quyền Admin", "Error");
        clearAuthStorage();
        setIsLoading(false);
        return;
      }

      const loggedUser = {
        email: email.trim(),
        accountId,
        roleId: String(roleId),
      };

      saveAuthStorage(loggedUser, token);
      setUser(loggedUser);
      notify("Đăng Nhập Thành Công", "Success");
      setIsLoading(false);
      history.push("/");
    } catch (error) {
      console.log(error);
      clearAuthStorage();
      setIsLoading(false);
      notify("Sai tài khoản hoặc mật khẩu", "Error");
    }
  };
  return (
    <div>
      <img class="wave" src="images/wave.png" alt="" />
      <div class="container">
        <div class="img">
          <img src="images/bg.svg" />
        </div>
        <div class="login-content">
          <form action="index.html" className="form-login">
            <img src="images/avatar.svg" alt="" />
            <h2 class="login-title">
              Chào mừng bạn đến với VHGP - Tiện ích cư dân
            </h2>

            <div class="input-div one">
              <div class="i">
                <i class="fas fa-user"></i>
              </div>
              <div class="div">
                <h5>Tên Đăng Nhập</h5>
                <input
                  type="text"
                  class="input"
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  value={email}
                />
              </div>
            </div>
            <div class="input-div pass">
              <div class="i">
                <i class="fas fa-lock"></i>
              </div>
              <div class="div">
                <h5>Mật Khẩu</h5>
                <input
                  type="password"
                  class="input"
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  value={password}
                />
              </div>
            </div>
            <button
              type="submit"
              class="btn-login"
              value="Đăng Nhập"
              disabled={isLoading}
              onClick={(e) => {
                e.preventDefault();
                handleLogin();
              }}
            >
              {isLoading ? (
                <Spinner style={{ color: "rgb(100,100,100)" }}>
                  Loading...
                </Spinner>
              ) : (
                "Đăng Nhập"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
